import { useRootLoaderData } from './useRootLoaderData'

export const useTrustpilotData = () => {
  const rootData = useRootLoaderData();

  return rootData!.trustpilotData;
}
